import ApiClient from './ApiClient';

class AiAgentsAPI extends ApiClient {
  constructor() {
    super('ai_agents', { accountScoped: true });
  }

  getAgents() {
    return axios.get(this.url);
  }

  getAgent(agentId) {
    return axios.get(`${this.url}/${agentId}`);
  }

  createAgent(data) {
    return axios.post(this.url, data);
  }

  updateAgent(agentId, data) {
    return axios.patch(`${this.url}/${agentId}`, data);
  }

  deleteAgent(agentId) {
    return axios.delete(`${this.url}/${agentId}`);
  }

  getConversations(agentId) {
    return axios.get(`${this.url}/${agentId}/ai_agent_conversations`);
  }

  getConversation(agentId, conversationId) {
    return axios.get(
      `${this.url}/${agentId}/ai_agent_conversations/${conversationId}`
    );
  }

  createConversation(agentId) {
    return axios.post(`${this.url}/${agentId}/ai_agent_conversations`);
  }

  deleteConversation(agentId, conversationId) {
    return axios.delete(
      `${this.url}/${agentId}/ai_agent_conversations/${conversationId}`
    );
  }

  addParticipant(agentId, conversationId, userId) {
    return axios.post(
      `${this.url}/${agentId}/ai_agent_conversations/${conversationId}/add_participant`,
      { user_id: userId }
    );
  }

  removeParticipant(agentId, conversationId, userId) {
    return axios.delete(
      `${this.url}/${agentId}/ai_agent_conversations/${conversationId}/remove_participant`,
      { data: { user_id: userId } }
    );
  }

  /**
   * Send message with SSE streaming support.
   * Returns a fetch Response so the caller can read the stream.
   */
  sendMessageStream(agentId, conversationId, content) {
    const url = `${this.url}/${agentId}/ai_agent_conversations/${conversationId}/send_message`;

    // Read auth headers from session cookie (devise_token_auth)
    const headers = { 'Content-Type': 'application/json' };

    try {
      const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith('oh_d_session_info='));
      if (cookieValue) {
        const authData = JSON.parse(
          decodeURIComponent(cookieValue.split('=').slice(1).join('='))
        );
        if (authData['access-token']) {
          headers['access-token'] = authData['access-token'];
          headers['token-type'] = authData['token-type'] || 'Bearer';
          headers['client'] = authData['client'];
          headers['expiry'] = authData['expiry'];
          headers['uid'] = authData['uid'];
        }
      }
    } catch {
      // fallback: proceed without auth headers
    }

    return fetch(url, {
      method: 'POST',
      headers,
      credentials: 'same-origin',
      body: JSON.stringify({ content }),
    });
  }
}

export default new AiAgentsAPI();
